<template>
   <div ref="slideProgress" class="w-100 progress-wrapper" 
        v-touch-start="detectMouseDown" 
        v-touch-end="detectMouseUp" 
        @mousedown="detectMouseDown" 
        @mouseup="detectMouseUp"
    >
        <div :style="'width:'+progress+'%'" class="progress" ref="progressBar">
            <div class="dot-seek" :style="'left:'+positionDot" ref="dotSeek"></div>
            <div class="tooltiptext" id="tooltiptext"
                    ref="tooltipProgress" 
                    :style="'left:'+positionTooltip"
                >
                {{ formatStreamTime(Math.round(currentPlayingTime)) }}
            </div>
        </div>
    </div>
</template>

<script>
import HelperMixins from "@/mixins/HelperMixins";

export default {
   name: "SlideProgress",
   mixins: [ HelperMixins ],
   props: {
       videoDuration: {
            type: Number,
            default: 0
        },
        currentPlayingTime: {
            type: Number,
            default: 0
        },
   },
   computed: {
       positionDot() {
            if (this.progress >= 50)
                return `calc(${this.progress}% - 9px)`;

            else 
                return `calc(${this.progress}% - 3px)`;
       },
   },
   data() {
        return {
            progress: 0,
            wrapperWidth: 0,
            newPlayingTime: 0,
            isUpdatingTime: false,
            positionTooltip: 0,
            tooltipWidth: 0
        }
   },
   watch: {
       currentPlayingTime(val) {
            if (!this.isUpdatingTime) {
                this.newPlayingTime = val;
                this.getProgressByValue(this.newPlayingTime);
            }
        },
        progress(val) {
            if (val >= 99)
                this.progress = 100;

            this.tooltipWidth = this.tooltipWidth || this.$refs.tooltipProgress.clientWidth; // set initial progressbar width
            this.wrapperWidth = this.wrapperWidth || this.$refs.slideProgress.clientWidth // set initial progressbar width

            if (this.progress*this.wrapperWidth/100 < this.tooltipWidth/2 && this.progress < 50) {
                return this.positionTooltip = `0`;
            }
            else if (this.progress*this.wrapperWidth/100 >= this.tooltipWidth/2 && this.progress < 50) {
                return this.positionTooltip = `calc(${this.progress}% - (${this.tooltipWidth}px / 2) + 5px)`;
            }
            else if (this.wrapperWidth - (this.progress*this.wrapperWidth/100) < this.tooltipWidth/2 && this.progress > 50) {
                return this.positionTooltip = `calc(${this.progress}% - ${this.tooltipWidth}px)`;
            }
            else {
                return this.positionTooltip = `calc(${this.progress}% - (${this.tooltipWidth}px / 2) - 5px)`;
            }
        }
    },
    mounted(){
        //add a listener that will listen to window resize and modify progress width accordingly
        window.addEventListener('resize', this.windowResize, false)
    },
    methods: {
        getClickPosition(e){
            if (e.target.className === "dot-seek")
                return;

            this.wrapperWidth = this.wrapperWidth || this.$refs.slideProgress.clientWidth // set initial progressbar width

            // get the seek width
            let seekWidth = e.offsetX

            // change seek position
            this.progress = (seekWidth / this.wrapperWidth) * 100;

            this.newPlayingTime = (this.progress * this.videoDuration) / 100;
        },
        getProgressByValue(val) {
            this.wrapperWidth = this.wrapperWidth || this.$refs.slideProgress.clientWidth // set initial progressbar width
            this.progress = (val * 100) / this.videoDuration;
        },
        detectMouseDown(e){
            e.preventDefault(); // prevent browser from moving objects, following links etc
            // start listening to mouse movements
            this.isUpdatingTime = true;
            // this.$emit("setPlayer", false);
            // this.$refs.slideProgress.addEventListener("mousemove", this.getClickPosition, false)
        },
        detectMouseUp(e){
            e.preventDefault();
           // start listening to mouse movements
           this.getClickPosition(e);
            // this.$refs.slideProgress.removeEventListener("mousemove", this.getClickPosition, false);
            this.$nextTick(() => {
                this.$emit("setCurrentTime", this.newPlayingTime)
                this.isUpdatingTime = false;
                this.$emit("setPlayer", true)
            })
        },
        windowResize(){
            let prog = this
            setTimeout(()=>{
                prog.wrapperWidth = prog.$refs.slideProgress.offsetWidth
            }, 200)
        },
   }
};
</script>
<style lang="scss">
.progress-wrapper{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 6px;
    position: relative;
    background: #e1e1e1;
    cursor: pointer;
    border-radius: 8px;
    .progress{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: $color-primary;
        height: 6px;
        border-radius: 8px;
        .dot-seek {
            width: 12px;
            height: 12px;
            background: $color-primary;
            border-radius: 50%;
            position: absolute;
            z-index: 1;
        }
        .tooltiptext {
            visibility: hidden;
            background-color: $color-primary-light;
            color: #fff;
            text-align: center;
            padding: 1rem 1rem;
            border-radius: 6px;
            position: absolute;
            z-index: 1;
            top: -3rem;
        }

        &:hover .tooltiptext {
            visibility: visible;
        }
  }
}
</style>